import { IndexContainer, IndexHeader, CardGrid, IndexCard } from '../../../styles/global'

export function ElectricalIndex() {
  const gradient = 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
  const accentColor = '#f59e0b'

  const calculators = [
    {
      title: 'Circuitos',
      description:
        'Calculadora para dimensionamento de circuitos elétricos, considerando potência instalada, tipo de carga, tensão e fator de demanda. Auxilia na definição da corrente, seção dos condutores e proteção adequada',
      path: '/eletrica/circuitos',
      icon: '⚡',
      popular: true,
    },
    {
      title: 'Eletroduto',
      description:
        'Calculadora para dimensionamento de eletrodutos, com base na quantidade e bitola dos condutores. Verifica a ocupação máxima conforme a NBR 5410, garantindo segurança e viabilidade da instalação',
      path: '/eletrica/eletroduto',
      icon: '🔌',
      popular: true,
    },
  ]

  return (
    <IndexContainer>
      <IndexHeader $gradient={gradient}>
        <div className="header-content">
          <h1>⚡ Instalações Elétricas</h1>
          <p className="subtitle">
            Ferramentas completas para dimensionamento de circuitos e componentes de instalações elétricas prediais
          </p>
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number">{calculators.length}</span>
              <span className="stat-label">Calculadoras</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{calculators.filter((c) => c.popular).length}</span>
              <span className="stat-label">Mais Usadas</span>
            </div>
          </div>
        </div>
      </IndexHeader>

      <div className="content-wrapper">
        <h2>Calculadoras Disponíveis</h2>
        <CardGrid>
          {calculators.map((calc, index) => (
            <IndexCard
              key={index}
              to={calc.path}
              $popular={calc.popular}
              $gradient={gradient}
              $accentColor={accentColor}
            >
              {calc.popular && <span className="popular-badge">Popular</span>}
              <span className="card-icon">{calc.icon}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </IndexCard>
          ))}
        </CardGrid>
      </div>
    </IndexContainer>
  )
}
